import { render, staticRenderFns } from "./SiteNavDesktopV2ShopNav.vue?vue&type=template&id=46db9946&scoped=true&lang=pug"
import script from "./SiteNavDesktopV2ShopNav.vue?vue&type=script&lang=js"
export * from "./SiteNavDesktopV2ShopNav.vue?vue&type=script&lang=js"
import style0 from "./SiteNavDesktopV2ShopNav.vue?vue&type=style&index=0&id=46db9946&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46db9946",
  null
  
)

export default component.exports